export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/cross.f1e65e62.svg","height":11,"width":10,"blurWidth":0,"blurHeight":0};